export default __webpack_public_path__ + "static/media/um.d21917ae.svg";